import {User} from './user.model';
import {Client} from './client.model';
import {OrgUnit} from './orgUnit.model';
import {ClientPlacementEvent} from './clientPlacementEvent.model';
import {ClientDiagnosis} from './clientDiagnosis.model';
import {ClientEpisode} from './clientEpisode.model';

export class ClientPlacement {
    id: string;
    startDate: string;
    endDate: string;
    adjustedStartDate: string;
    adjustedEndDate: string;
    orgUnit: OrgUnit;
    responsibleUser: User;
    primaryPhysician: User;
    externalId: string;
    diagnoses: Array<ClientDiagnosis> = [];
    events: Array<ClientPlacementEvent> = [];
    client: Client;
    clientEpisode: ClientEpisode;
    temporaryOpenDate: string;

    constructor(clientPlacement: any) {
        if (clientPlacement) {
            this.id = clientPlacement.id;
            this.startDate = clientPlacement.startDate;
            this.endDate = clientPlacement.endDate;
            this.adjustedStartDate = clientPlacement.adjustedStartDate;
            this.adjustedEndDate = clientPlacement.adjustedEndDate;
            this.orgUnit = new OrgUnit(clientPlacement.orgUnit);
            this.responsibleUser = new User(clientPlacement.responsibleUser);
            this.primaryPhysician = new User(clientPlacement.primaryPhysician);
            this.externalId = clientPlacement.externalId;
            if (clientPlacement.diagnoses) {
                clientPlacement.diagnoses.forEach(diagnosis => {
                    this.diagnoses.push(new ClientDiagnosis(diagnosis));
                });
            }
            if (clientPlacement.events) {
                clientPlacement.events.forEach(event => {
                    this.events.push(new ClientPlacementEvent(event));
                });
            }
            this.client = new Client(clientPlacement.client);
            this.clientEpisode = new ClientEpisode(clientPlacement.clientEpisode);
            this.temporaryOpenDate = clientPlacement.temporaryOpenDate;
        }
    }
}
